export default __webpack_public_path__ + "static/devops-casestudy-2-7f6991c749ca7506f79f9cf95a62d678.png";